/**
 * @generated SignedSource<<014464476e3c70754a84ca53858dc516>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rulesPage_ExportQuery$variables = Record<PropertyKey, never>;
export type rulesPage_ExportQuery$data = {
  readonly attributionMemoryExport: string;
};
export type rulesPage_ExportQuery = {
  response: rulesPage_ExportQuery$data;
  variables: rulesPage_ExportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "attributionMemoryExport",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_ExportQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "rulesPage_ExportQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "661cf78d702a44a88a9116e38b9bb1ca",
    "id": null,
    "metadata": {},
    "name": "rulesPage_ExportQuery",
    "operationKind": "query",
    "text": "query rulesPage_ExportQuery {\n  attributionMemoryExport\n}\n"
  }
};
})();

(node as any).hash = "bed4dff4eaa90e92cd9bd7129313a955";

export default node;
